export enum TransferDialogStatus {
  Complete = 'complete',
  Confirm = 'confirm',
  Error = 'error',
  Waiting = 'waiting',
  AwaitingApproval = 'awaitingApproval',
  Scheduled= 'scheduled',
}
